import { useState } from "react";
import { HorizontalLineDivider } from "../../UI/HorizontalLineDivider.tsx";
import { AddPlanBonusModal } from "./AddPlanBonusModal.tsx";
import { ManualBonusFormInput, formatBonus } from "./planBonusUtils.ts";

type Props = {
  bonuses: ManualBonusFormInput[];
  onChange: (bonuses: ManualBonusFormInput[]) => void;
};

export function PlanBonusesEditor({ bonuses, onChange }: Props) {
  const [showModal, setShowModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState<number | undefined>(
    undefined,
  );

  return (
    <div className={"flex flex-col space-y-3 w-full"}>
      <div className={"flex items-center space-x-4"}>
        <HorizontalLineDivider />
        <p className={"whitespace-nowrap font-bold"}>Bonuses</p>
        <HorizontalLineDivider />
      </div>

      {showModal && (
        <AddPlanBonusModal
          initialValue={
            editingIndex !== undefined ? bonuses[editingIndex] : undefined
          }
          onClose={() => {
            setShowModal(false);
            setEditingIndex(undefined);
          }}
          onConfirm={(bonus) => {
            if (editingIndex !== undefined) {
              onChange(bonuses.map((b, i) => (i === editingIndex ? bonus : b)));
            } else {
              onChange([...bonuses, bonus]);
            }
            setShowModal(false);
            setEditingIndex(undefined);
          }}
        />
      )}

      {bonuses.length > 0 && (
        <div className="flex flex-col gap-2">
          {bonuses.map((bonus, i) => (
            <div
              key={i}
              className="flex items-center justify-between px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg"
            >
              <span className="text-sm font-medium text-blue-800">
                {formatBonus(bonus)}
              </span>
              <div className="flex items-center gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setEditingIndex(i);
                    setShowModal(true);
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm"
                >
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => onChange(bonuses.filter((_, j) => j !== i))}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div>
        <button
          type="button"
          onClick={() => {
            setEditingIndex(undefined);
            setShowModal(true);
          }}
          className="text-sm text-blue-600 hover:text-blue-800 font-medium"
        >
          + Add bonus
        </button>
      </div>
    </div>
  );
}
